/* Veepunzel – Feinschliff am Kontaktformular.
   Shopify liefert die Feldbeschriftungen aus locales/de.json. „Kommentar“ passt
   auf einer Anfrageseite nicht, lässt sich über die Section-Einstellungen aber
   nicht ändern. Statt die große Sprachdatei anzufassen, benennen wir das Feld
   hier um und setzen einen hilfreichen Platzhalter. */
(function () {
  'use strict';

  var TEXTE = {
    'fachkunden': {
      label: 'Deine Nachricht',
      placeholder: 'Einrichtung, gewünschtes Material und ungefähre Stückzahl – dann geht das Angebot schneller raus.'
    },
    'kontakt': {
      label: 'Deine Nachricht',
      placeholder: 'Worum geht es? Schreib einfach los.'
    }
  };

  function seite() {
    var teile = window.location.pathname.split('/');
    return teile[teile.length - 1] || '';
  }

  function anpassen() {
    var texte = TEXTE[seite()];
    if (!texte) return;

    var form = document.querySelector('form[action*="/contact"]');
    if (!form) return;

    var feld = form.querySelector('textarea');
    if (!feld) return;

    feld.setAttribute('placeholder', texte.placeholder);

    var label = feld.id ? form.querySelector('label[for="' + feld.id + '"]') : null;
    if (label && label.textContent.trim() !== texte.label) {
      label.textContent = texte.label;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anpassen);
  } else {
    anpassen();
  }
})();
